import "../../styles/cars.css";

export default function CarCard({ car, onClick }) {

  const doorLabel = car.doorStatus === 1 ? "Aberta" : "Fechada";
  const doorColor = car.doorStatus === 1 ? "#ff4d4d" : "#4caf50";

  return (
    <div className="wagon" onClick={onClick}>

      {/* Porta visual */}
      <div
        className="wagon-door"
        style={{
          backgroundColor: doorColor,
          boxShadow: "0 0 8px " + doorColor
        }}
      ></div>

      {/* Infos */}
      <div className="wagon-info">
        <p>{car.name}</p>

        {/* {car.doorStatus !== null && (
          <p>🚪 Porta: <b>{doorLabel}</b></p>
        )}

        {car.temperature !== null && (
          <p>🌡 {car.temperature}°C</p>
        )} */}
      </div>
    </div>
  );
}
